import * as React from 'react';

import styles from './styles.module.scss';

export const Label = ({ ...other }) => (
  <p className={styles.field_label} {...other} />
);

export default Label;
